import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <TopicStatus @topic={{this.item}} @disableActions={{true}} />
<div class="topic-title">{{replace-emoji this.item.title}}</div>
<div class="topic-categories">
  {{bound-category-link
    this.item.category
    ancestors=this.item.category.predecessors
    hideParent=true
    link=false
  }}
</div>
*/
{
  "id": "ucnoS4pV",
  "block": "[[[8,[39,0],null,[[\"@topic\",\"@disableActions\"],[[30,0,[\"item\"]],true]],null],[1,\"\\n\"],[10,0],[14,0,\"topic-title\"],[12],[1,[28,[35,1],[[30,0,[\"item\",\"title\"]]],null]],[13],[1,\"\\n\"],[10,0],[14,0,\"topic-categories\"],[12],[1,\"\\n  \"],[1,[28,[35,2],[[30,0,[\"item\",\"category\"]]],[[\"ancestors\",\"hideParent\",\"link\"],[[30,0,[\"item\",\"category\",\"predecessors\"]],true,false]]]],[1,\"\\n\"],[13]],[],false,[\"topic-status\",\"replace-emoji\",\"bound-category-link\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/topic-row.hbs",
  "isStrictMode": false
});